(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class SoleCountdown extends HTMLElement {
    connectedCallback() {
      const raw = this.dataset.deadline;
      this.deadline = raw ? new Date(raw).getTime() : NaN;
      if (!this.deadline || isNaN(this.deadline)) { this.hidden = true; return; }

      this.fields = {
        days: this.querySelector('[data-cd="days"]'),
        hours: this.querySelector('[data-cd="hours"]'),
        minutes: this.querySelector('[data-cd="minutes"]'),
        seconds: this.querySelector('[data-cd="seconds"]'),
      };
      this.tick();
      // Mark painted so the CSS reveals the digits and drops the static-date fallback. The inline
      // init snippet sets the same attribute during parse; whichever runs first wins, the other
      // is a no-op. This path is what covers Section-Rendering-API injection, where inline
      // scripts never execute but connectedCallback still fires.
      this.setAttribute('data-painted', '');
      this.timer = setInterval(() => this.tick(), 1000);
    }

    tick() {
      const remaining = this.deadline - Date.now();
      if (remaining <= 0) {
        this.stop();
        this.expire();
        return;
      }
      const s = Math.floor(remaining / 1000);
      const days = Math.floor(s / 86400);
      const hours = Math.floor((s % 86400) / 3600);
      const minutes = Math.floor((s % 3600) / 60);
      const seconds = s % 60;
      this.set('days', days);
      this.set('hours', hours);
      this.set('minutes', minutes);
      this.set('seconds', seconds);
      // a11y: do NOT rewrite aria-label every second (screen-reader spam). The element keeps its
      // static aria-label ("Time left…"); the ticking numerals are role=timer (aria-live off) so they
      // aren't announced, and the visible deadline label carries the human time.
    }

    set(key, value) {
      const el = this.fields[key];
      if (el) el.textContent = String(value).padStart(2, '0');
    }

    expire() {
      // Collapse the now-contradictory promo message. Also the CLS fix: keeping it alongside the
      // expiry notice wraps the bar to a second line at phone widths (measured 0.151 shift at 375px).
      // No-op outside the announcement bar, e.g. the /promotions hero clock.
      const bar = this.closest('.sole-announcement');
      if (bar) bar.classList.add('sole-announcement--expired');
      const text = this.dataset.expiredText;
      if (text) {
        this.replaceChildren();
        const span = document.createElement('span');
        span.className = 'sole-countdown__expired';
        span.setAttribute('role', 'status');   // announce the one-time expiry change politely
        span.textContent = text;
        this.appendChild(span);
        this.setAttribute('aria-label', text);
      } else {
        this.hidden = true;
      }
    }

    stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
    disconnectedCallback() { this.stop(); }
  }
  if (!customElements.get('sole-countdown')) customElements.define('sole-countdown', SoleCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SoleHeader extends HTMLElement {
    connectedCallback() {
      // Condense-on-scroll for the sticky header (passive + rAF-throttled).
      this._ticking = false;
      // Publish the VISIBLE header height, so in-page sticky strips (e.g. the collection .ustrip, which
      // uses top:var(--header-height)) sit flush under the header rather than leaving a gap that page
      // content scrolls through. This tracks the header itself, not its height-locked wrapper.
      // Driven by a ResizeObserver rather than the scroll handler. The old version re-read offsetHeight
      // in the same frame it wrote the class, which forced a synchronous reflow on every scroll frame and
      // still latched a mid-transition value (a 93px header published 74px) that nothing corrected once
      // scrolling stopped. A ResizeObserver fires on the real height changes instead, including the last
      // frame of the condense transition, so the value always settles correctly.
      // This is the ONLY writer of --header-height. Do not add another: a second writer on document.body
      // would win the cascade over this one and silently mask it.
      this._setHeaderHeight = () =>
        document.documentElement.style.setProperty('--header-height', Math.round(this.getBoundingClientRect().height) + 'px');
      this._onScroll = () => {
        if (this._ticking) return;
        this._ticking = true;
        requestAnimationFrame(() => {
          this.classList.toggle('is-condensed', window.scrollY > 60);
          this._ticking = false;
        });
      };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      if (window.ResizeObserver) {
        this._ro = new ResizeObserver(() => this._setHeaderHeight());
        this._ro.observe(this);
      } else {
        this._onResize = () => this._setHeaderHeight();
        window.addEventListener('resize', this._onResize, { passive: true });
      }
      this._setHeaderHeight();
      this._onScroll(); // set initial state (covers reload mid-page)

      this.toggle = this.querySelector('.sole-header__toggle');
      this.panel = this.querySelector('.sole-header__mobile');
      if (!this.toggle || !this.panel) return;
      this._onToggle = () => this.setOpen(this.toggle.getAttribute('aria-expanded') !== 'true');
      // Escape closes; Tab is trapped inside the open panel (WCAG focus management for the overlay).
      this._onKey = (e) => {
        if (!this.classList.contains('nav-open')) return;
        if (e.key === 'Escape') { this.setOpen(false); return; }
        if (e.key === 'Tab') {
          const f = this.panel.querySelectorAll('a[href], button:not([disabled])');
          if (!f.length) return;
          const first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      };
      this.toggle.addEventListener('click', this._onToggle);
      this.addEventListener('keydown', this._onKey);
      // Close affordances: the X button + clicking the backdrop.
      this.panel.querySelectorAll('[data-nav-close]').forEach((el) => el.addEventListener('click', () => this.setOpen(false)));
      this._backdrop = this.querySelector('[data-nav-backdrop]');
      if (this._backdrop) this._backdrop.addEventListener('click', () => this.setOpen(false));
    }
    setOpen(open) {
      this.toggle.setAttribute('aria-expanded', String(open));
      this.classList.toggle('nav-open', open);   // drives the slide + backdrop (CSS)
      this.panel.inert = !open;                   // closed panel out of the tab order
      document.documentElement.style.overflow = open ? 'hidden' : '';   // body scroll-lock
      if (open) {
        const first = this.panel.querySelector('a, button');
        if (first) first.focus();
      } else {
        this.toggle.focus();
      }
    }
    disconnectedCallback() {
      if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      // The theme editor re-renders sections on every setting change, so an undisconnected observer
      // would accumulate one live instance per edit.
      if (this._ro) { this._ro.disconnect(); this._ro = null; }
      this.toggle?.removeEventListener('click', this._onToggle);
      this.removeEventListener('keydown', this._onKey);
    }
  }
  if (!customElements.get('sole-header')) customElements.define('sole-header', SoleHeader);

  class SoleSearchModal extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-search-trigger]');
      this.dialog = this.querySelector('dialog');
      this.input = this.querySelector('[data-search-input]');
      this.listbox = this.querySelector('[data-search-listbox]');
      this.empty = this.querySelector('[data-search-empty]');
      this.status = this.querySelector('[data-search-status]');
      this.form = this.querySelector('form');
      this.closeBtn = this.querySelector('[data-search-close]');
      if (!this.trigger || !this.dialog || !this.input || !this.listbox) return;
      if (typeof this.dialog.showModal !== 'function') return; // no <dialog> support → trigger stays a plain link to /search

      this.endpoint = (window.Theme && Theme.routes && Theme.routes.predictive_search_url) || '/search/suggest';
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.activeIndex = -1;
      this.options = [];
      this.debounceId = null;
      this.controller = null;
      this.lastFocus = null;

      this.trigger.addEventListener('click', (e) => { e.preventDefault(); this.open(); });
      this.closeBtn.addEventListener('click', () => this.close());
      // backdrop click (target is the <dialog> itself, outside the centered panel)
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.close(); });
      this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); }); // Esc
      this.dialog.addEventListener('close', () => this.afterClose());
      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('keydown', (e) => this.onKey(e));
      this.form.addEventListener('submit', (e) => { if (this.input.value.trim() === '') e.preventDefault(); });
      // Mouse: clicking an option navigates (options carry data-url; no nested <a>).
      this.listbox.addEventListener('click', (e) => {
        const opt = e.target.closest('[role="option"]');
        if (opt && opt.dataset.url) window.location.href = opt.dataset.url;
      });
    }

    open() {
      this.lastFocus = document.activeElement;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.trigger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => this.input.focus());
    }

    close() {
      if (this.reduce) { this.dialog.close(); return; }
      this.dialog.classList.add('is-closing');
      const done = () => {
        this.dialog.classList.remove('is-closing');
        this.dialog.removeEventListener('animationend', done);
        this.dialog.close();
      };
      this.dialog.addEventListener('animationend', done);
    }

    afterClose() {
      document.documentElement.style.overflow = '';
      this.trigger.setAttribute('aria-expanded', 'false');
      this.input.setAttribute('aria-expanded', 'false');
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') this.lastFocus.focus();
    }

    onInput() {
      const q = this.input.value.trim();
      clearTimeout(this.debounceId);
      if (q.length < 2) { this.clearResults(); return; }
      this.debounceId = setTimeout(() => this.search(q), 250);
    }

    async search(q) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const url = this.endpoint
        + '?q=' + encodeURIComponent(q)
        + '&section_id=sole-predictive-search'
        + '&resources[type]=product,page,query&resources[limit]=6';
      try {
        const res = await fetch(url, { signal: this.controller.signal });
        if (!res.ok) return;
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const items = doc.querySelectorAll('li.sole-search__opt');
        this.listbox.replaceChildren(...items);
        this.options = Array.from(this.listbox.querySelectorAll('[role="option"]'));
        this.activeIndex = -1;
        this.input.setAttribute('aria-expanded', this.options.length ? 'true' : 'false');
        this.input.removeAttribute('aria-activedescendant');
        const products = this.listbox.querySelectorAll('.sole-search__opt--product').length;
        this.announce(products ? products + ' product results for ' + q : 'No product results for ' + q);
      } catch (err) {
        if (err && err.name === 'AbortError') return;
      }
    }

    clearResults() {
      this.listbox.replaceChildren();
      this.options = [];
      this.activeIndex = -1;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
    }

    announce(msg) { if (this.status) this.status.textContent = msg; }

    onKey(e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!this.options.length) return;
        e.preventDefault();
        const dir = e.key === 'ArrowDown' ? 1 : -1;
        this.activeIndex = (this.activeIndex + dir + this.options.length) % this.options.length;
        this.options.forEach((o, i) => o.setAttribute('aria-selected', i === this.activeIndex ? 'true' : 'false'));
        const active = this.options[this.activeIndex];
        this.input.setAttribute('aria-activedescendant', active.id);
        active.scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter') {
        const active = this.options[this.activeIndex];
        if (active) {
          e.preventDefault();
          const url = active.getAttribute('data-url');
          if (url) window.location.href = url;
        }
        // else: let the form submit to the search page
      }
    }

    disconnectedCallback() {
      clearTimeout(this.debounceId);
      if (this.controller) this.controller.abort();
    }
  }
  if (!customElements.get('sole-search-modal')) customElements.define('sole-search-modal', SoleSearchModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class SoleHeroSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sole-hero__track');
      this.slides = Array.from(this.querySelectorAll('.sole-hero__slide'));
      if (!this.track || this.slides.length <= 1) {
        this.setSlideFocusability();
        return;
      }
      this.dots = Array.from(this.querySelectorAll('.sole-hero__dot'));
      this.live = this.querySelector('.sole-hero__live');
      this.index = 0;
      this.timer = null;
      this.interval = parseInt(this.dataset.interval, 10) || 6000;
      this.autoplay = this.dataset.autoplay === 'true';
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.querySelector('.sole-hero__nav--prev')?.addEventListener('click', () => this.go(this.index - 1, true));
      this.querySelector('.sole-hero__nav--next')?.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));

      this._onKey = (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1, true); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1, true); }
      };
      this.addEventListener('keydown', this._onKey);
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this._onVis = () => (document.hidden ? this.stop() : this.start());
      document.addEventListener('visibilitychange', this._onVis);

      let startX = null;
      let startY = null;
      this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; startY = e.touches[0].clientY; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        const dy = e.changedTouches[0].clientY - startY;
        /* Axis guard. Without the dy comparison a diagonal flick during a vertical scroll changed the
           slide, and every mobile visitor scrolls past a hero taller than their viewport. */
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) this.go(this.index + (dx < 0 ? 1 : -1), true);
        startX = null;
        startY = null;
      }, { passive: true });

      this.update(false);
      this.start();
    }

    go(i, userInitiated) {
      const n = this.slides.length;
      this.index = ((i % n) + n) % n;
      this.update(true);
      /* User intent ends autoplay for the session. This used to stop() then start(), restarting the very
         timer the visitor had just overruled. See the note on the duplicate class below. */
      if (userInitiated) { this.userStopped = true; this.stop(); }
    }

    update(announce) {
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.setSlideFocusability();
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
      if (announce && this.live) this.live.textContent = `Slide ${this.index + 1} of ${this.slides.length}`;
    }

    setSlideFocusability() {
      this.slides.forEach((slide, i) => {
        const active = i === (this.index || 0);
        if (this.slides.length > 1) {
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        }
        slide.querySelectorAll('a, button').forEach((el) => { el.tabIndex = active ? 0 : -1; });
      });
    }

    start() {
      if (this.userStopped || !this.autoplay || this.reduce || this.slides.length <= 1) return;
      this.stop();
      this.timer = setInterval(() => this.go(this.index + 1, false), this.interval);
    }

    stop() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }

    disconnectedCallback() {
      this.stop();
      if (this._onVis) document.removeEventListener('visibilitychange', this._onVis);
    }
  }
  /* NOTE: sections/promo-hero.liquid defines its own SoleHeroSlider behind the same guard. Whichever
     section's script runs first wins and the other definition is silently discarded, so the two copies
     MUST be kept in step. A slider fix applied to only one of them lands in a class that never runs -
     which is exactly what happened with the autoplay and swipe fixes on 2026-08-26. */
  if (!customElements.get('sole-hero-slider')) customElements.define('sole-hero-slider', SoleHeroSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-hero"] && !Shopify.designMode) return;
  try {
    
  class SoleHeroSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sole-hero__track');
      this.slides = Array.from(this.querySelectorAll('.sole-hero__slide'));
      if (!this.track || this.slides.length <= 1) { this.setSlideFocusability(); return; }
      this.dots = Array.from(this.querySelectorAll('.sole-hero__dot'));
      this.live = this.querySelector('.sole-hero__live');
      this.index = 0; this.timer = null;
      this.interval = parseInt(this.dataset.interval, 10) || 7000;
      this.autoplay = this.dataset.autoplay === 'true';
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.querySelector('.sole-hero__nav--prev')?.addEventListener('click', () => this.go(this.index - 1, true));
      this.querySelector('.sole-hero__nav--next')?.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));
      this._onKey = (e) => { if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1, true); } else if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1, true); } };
      this.addEventListener('keydown', this._onKey);
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this._onVis = () => (document.hidden ? this.stop() : this.start());
      document.addEventListener('visibilitychange', this._onVis);
      let startX = null;
      let startY = null;
      this.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; startY = e.touches[0].clientY; }, { passive: true });
      this.addEventListener('touchend', (e) => { if (startX === null) return; const dx = e.changedTouches[0].clientX - startX; const dy = e.changedTouches[0].clientY - startY; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) this.go(this.index + (dx < 0 ? 1 : -1), true); startX = null; startY = null; }, { passive: true });
      this.update(false); this.start();
    }
    /* `u` means the visitor chose this slide. It used to stop() then start(), which restarted the same
       8s timer they had just overruled: click dot 3, and 8s later you are on slide 4 with your mouse still
       on the dot you pressed. On mobile a deliberate swipe was yanked back the same way, measured at 7.3s.
       User intent now ends autoplay for the session, which also gives touch users the stop mechanism the
       hover and focus handlers only ever gave mouse and keyboard (WCAG 2.2.2). */
    go(i, u) { const n = this.slides.length; this.index = ((i % n) + n) % n; this.update(true); if (u) { this.userStopped = true; this.stop(); } }
    update(a) { this.track.style.transform = `translateX(-${this.index * 100}%)`; this.setSlideFocusability(); this.dots.forEach((dot, i) => dot.setAttribute('aria-current', i === this.index ? 'true' : 'false')); if (a && this.live) this.live.textContent = `Slide ${this.index + 1} of ${this.slides.length}`; }
    setSlideFocusability() { this.slides.forEach((slide, i) => { const active = i === (this.index || 0); if (this.slides.length > 1) { if (active) slide.removeAttribute('aria-hidden'); else slide.setAttribute('aria-hidden', 'true'); } slide.querySelectorAll('a, button').forEach((el) => { el.tabIndex = active ? 0 : -1; }); }); }
    start() { if (this.userStopped || !this.autoplay || this.reduce || this.slides.length <= 1) return; this.stop(); this.timer = setInterval(() => this.go(this.index + 1, false), this.interval); }
    stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
    disconnectedCallback() { this.stop(); if (this._onVis) document.removeEventListener('visibilitychange', this._onVis); }
  }
  if (!customElements.get('sole-hero-slider')) customElements.define('sole-hero-slider', SoleHeroSlider);

  } catch(e) { console.error(e); }
})();
})();
